import { db } from "../firebase/config";
import { ref, runTransaction } from "firebase/database";

/**
 * Sovereign ID Generation Service
 * Generates unique, formatted, and atomic IDs for the clinical network.
 * 
 * @param {string} type - Identity node type (patient, doctor, caregiver, hospital, appointment)
 * @returns {Promise<string>} - Formatted clinical ID (e.g., PT-00001)
 */
export const generateClinicalId = async (type) => {
  const typeMap = {
    patient: "PT",
    doctor: "DR",
    caregiver: "CG",
    hospital: "HSP",
    appointment: "APT",
    admin: "AD"
  };

  const prefix = typeMap[type] || "GEN";
  const counterRef = ref(db, `counters/${type}`);

  try {
    const result = await runTransaction(counterRef, (currentValue) => {
      // Initialize if node is empty, otherwise increment
      return (currentValue || 0) + 1;
    });

    if (result.committed) {
      const newCount = result.snapshot.val();
      // Pad with 5 zeros: 1 -> 00001
      const paddedCount = String(newCount).padStart(5, '0');
      return `${prefix}-${paddedCount}`;
    } else {
      throw new Error("ID_GENERATION_FAILURE: Transaction did not commit.");
    }
  } catch (error) {
    console.error(`OVERSIGHT_ERROR: Failed to provision ${type} identity code:`, error);
    throw error;
  }
};
